module.exports = __webpack_public_path__ + "img/password.7112e6ef.svg";